import { ConversationTypeSelector } from "PFApp/components/activity_form/form_selectors/conversation_type_selector";
import { FIELD_COMMUNICATION_TYPE_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { Controller, useFormContext } from "react-hook-form";

import { useActivityFormStore } from "../../activity_form_store";
import { FormSection, SectionProps } from "../form_section";

export const ConversationFormSection = ({ id, title }: SectionProps) => {
  const qaIdPrefix = useActivityFormStore((state) => state.qaIdPrefix);

  const { control } = useFormContext();

  return (
    <FormSection id={id} title={title} qaId={`${qaIdPrefix}-conversation}`}>
      <Controller
        name={FIELD_COMMUNICATION_TYPE_KEY}
        control={control}
        render={({ field }) => (
          <ConversationTypeSelector
            conversationType={field.value}
            onConversationTypeChange={field.onChange}
          />
        )}
      />
    </FormSection>
  );
};
